// userTypeSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Profile {
  _id: string;
  numberOfEmployees: string;
  numberOfActivities: string;
  locations: string[];
  reservation: boolean;
  legalCompanyName: string;
  companyDescription?: string;
  logo?: string | File | null;
  legalStatus?: string;
  legalIndividualName?: string;
  publicCompanyName?: string;
  mainAddress?: string;
  city?: string;
  professionalLicenseNumber?: string;
  postalCode?: string;
  stateRegion?: string;
  contactPhoneNumber?: string;
  countryCode?: string;
  firstName?: string;
  lastName?: string;
  website: string;
  user: string;
  type: string;
  __v: number;
}

interface ProfileTypeState {
  profile: Profile | null;
}

const initialState: ProfileTypeState = {
  profile: null,
};

const profileTypeSlice = createSlice({
  name: "ownProfile",
  initialState,
  reducers: {
    setOwnProfile: (state, action: PayloadAction<Profile>) => {
      state.profile = action.payload;
    },
  },
});

export const { setOwnProfile } = profileTypeSlice.actions;
export default profileTypeSlice.reducer;
